module.exports = __webpack_public_path__ + "img/kiss_ios_802.png";